export { default as CheckBox } from './CheckBox';
export { default as DatePicker } from './DatePicker';
export { default as RadioButton } from './RadioButton';
export { default as SelectField } from './SelectField';
export { default as StaticField } from './StaticField';
export { default as TextArea } from './TextArea';
export { default as TextField } from './TextField';

export const normalizeInteger = (value) => {
  if (!value) {
    return value;
  }
  const number = value.replace(/[^0-9]/g, '');
  return number;
};

export const normalizeDecimal = (value) => {
  if (!value) {
    return value;
  }
  const number = value.replace(/[^0-9.]/g, '');
  return number;
};

export const normalizeDate = (date) => {
  if (date) {
    try {
      return date.format('MMM D, YYYY');
    } catch {
      return date;
    }
  }
  return date;
};

export const normalizeCreditCard = (creditCardNumber) => {
  const cardNumber = removeNonIntegers(creditCardNumber);
  const standardSlices = [4, 4, 4, 4];
  const amexSlices = [4, 6, 5];

  if (cardNumber === undefined || !cardNumber.length) {
    return cardNumber;
  }

  const creditCardBrand = getCreditCardBrand(creditCardNumber);

  switch (creditCardBrand) {
    case 'visa':
    case 'discover':
    case 'jcb':
    case 'mastercard':
      return slicedCardNumber(standardSlices, cardNumber);
    case 'amex':
      return slicedCardNumber(amexSlices, cardNumber);
    default:
      return cardNumber;
  }
};

const getCreditCardBrand = (creditCardNumber) => {
  const cardNumber = removeNonIntegers(creditCardNumber);

  const visa = /^4/;
  const amex = /^3(4|7)/;
  const dinersClubCB = /^30[0-5]/;
  const dinersClubInt = /^36/;
  const discover = /^6(011|4[4-9]|5|22[1-9]{3})/;
  const masterCard = /^5[1-5]/;
  const jcb = /^35[0-9]{2}/;

  switch (true) {
    case visa.test(cardNumber):
      return 'visa';
    case amex.test(cardNumber):
      return 'amex';
    case dinersClubCB.test(cardNumber):
      return 'dinersclub';
    case dinersClubInt.test(cardNumber):
      return 'dinersclub';
    case discover.test(cardNumber):
      return 'discover';
    case masterCard.test(cardNumber):
      return 'mastercard';
    case jcb.test(cardNumber):
      return 'jcb';
    default:
      return '';
  }
};

const slicedCardNumber = (slices, creditCard) => {
  let start = 0;
  let formattedCardNumber = '';
  const cardNumber = removeNonIntegers(creditCard);
  slices.forEach((slicePoint) => {
    formattedCardNumber += `${cardNumber.slice(start, (start += slicePoint))} `;
  });
  // for (const slicePoint of slices) {
  //   formattedCardNumber += `${cardNumber.slice(start, (start += slicePoint))} `;
  // }
  return formattedCardNumber.trim();
};

const removeNonIntegers = (creditCardNumber) =>
  creditCardNumber !== undefined && creditCardNumber.replace(/[^\d]/g, '');
